import { calculatePaginationOffset, compareValues, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const sbomApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSoftwareList: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/sbom`,
                params: {
                    product_or_file_name: data.filter.product_or_file_name,
                    publisher: data.filter.publisher,
                    license_family: data.filter.license_family,
                    verified_matches: data.filter.verified_matches.join(","),
                    software_type: data.filter.software_type.join(","),
                    component_id: data.filter.component_id,
                    dependency_id: data.filter.dependency_id,
                    sort_by: convertSortToQueryString(data.sort),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getSoftwarePublishers: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/sbom/publishers`,
            }),
            transformResponse: (data) => {
                return data.sort((first, second) => compareValues(first.value, second.value, false));
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetSoftwareListQuery, useLazyGetSoftwarePublishersQuery } = sbomApi;
//# sourceMappingURL=sbom.api.js.map